import React from 'react';
import PropTypes from 'prop-types';
import styles from './Table.scss';

function TableRow({ rows, columns, isLoading, customNoRowsText, ...rest }) {
    if (
        !isLoading && ((Array.isArray(rows) && !rows.length) || !Array.isArray(rows))
    ) {
        return <div className={`${styles.TableNoRows}`}>{customNoRowsText || 'No data to show'}</div>;
    }

    return rows.map((item, rowIndex) => (
        <ul key={rowIndex}>
            {Array.isArray(columns) &&
            columns.length > 0 &&
            columns.filter(({ hideColumn = false }) => !hideColumn)
                .map(({ custom, key, maxWidth, rowClassName }, index) => (
                    <li
                        key={index}
                        style={maxWidth ? { minWidth: `${maxWidth}px`,
                            width: `${maxWidth}px`,
                            flex: `${maxWidth} 0 auto` } : {}}
                        className={`${rowClassName || ''}`}
                    >
                        <p>
                            {typeof custom === 'function'
                                ? custom(item[key], item, { rowIndex, ...rest })
                                : item[key]}
                        </p>
                    </li>
                ))}
        </ul>
    ));
}

TableRow.defaultProps = {
    columns: [],
    rows: [],
    isLoading: false,
    customNoRowsText: null,
};

TableRow.propTypes = {
    columns: PropTypes.arrayOf(PropTypes.shape),
    rows: PropTypes.arrayOf(PropTypes.shape),
    isLoading: PropTypes.bool,
    customNoRowsText: PropTypes.string || PropTypes.number,
};

export default TableRow;
